import { StyleProp, StyleSheet, ViewStyle } from "react-native";

import { BMPrimitives } from "@traveloka/district-bloom";
import View from "../View";
const ANIMATION_START_DELAY = BMPrimitives.BMAnimation.duration.instant;
const SCALE_MIN = 1 / 3;
const SCALE_MAX = 1;
const OPACITY_MIN = BMPrimitives.BMOpacity.washed;
const OPACITY_MAX = 1;
const DOT_SIZE = 12;
const DOT_COUNT = 3;

export type DotLoaderProps = {
  /**
   * Color of the dots
   * @default '#0194f3'
   */
  color?: string;
  /**
   * Custom style applied to the root element
   */
  style?: StyleProp<ViewStyle>;
};

export default function DotLoader(props: DotLoaderProps) {
  const { color = BMPrimitives.BMBrand.primary, style } = props;

  return (
    <View
      accessibilityRole="none"
      align="center"
      row
      justify="center"
      style={[styles.root, style]}
    >
      {Array.from({ length: DOT_COUNT }, (_, index) => {
        const dotStyle = [
          styles.dot,
          {
            animationDelay: `${ANIMATION_START_DELAY * index}ms`,
            backgroundColor: color,
          },
        ];

        return <View key={index} style={dotStyle} />;
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    gap: 2,
  },
  dot: {
    // @ts-expect-error react-native-web only
    animationDuration: `600ms`,
    animationIterationCount: "infinite",
    // 0% = 0ms
    // 33% = 200ms
    // 66%, 100% = 400ms - 600ms
    animationKeyframes: {
      "0%": {
        transform: `scale(${SCALE_MIN})`,
        opacity: OPACITY_MIN,
      },
      "33%": {
        transform: `scale(${SCALE_MAX})`,
        opacity: OPACITY_MAX,
      },
      "66%, 100%": {
        transform: `scale(${SCALE_MIN})`,
        opacity: OPACITY_MIN,
      },
    },
    animationTimingFunction: "ease-in-out",
    borderRadius: DOT_SIZE / 2,
    height: DOT_SIZE,
    width: DOT_SIZE,
  },
});
